export default __webpack_public_path__ + "static/media/merge-field.e7429889.svg";